const API_URL = process.env.REACT_APP_API_URL || 'https://sophia.aiexpertys.fr/api';

module.exports = API_URL;